import RectangleGrey from '../../images/RectangleGrey.png';
import Shape from '../../images/Shape.png';
function Footer() {
    return (


        <div className="footer"
            style={{
                padding: '13px',
                width: '100%',
                height: '190px',
                textAlign: 'center',
                // marginBottom: '20px',
                backgroundImage: `url(${RectangleGrey})`
            }}>

            <img src={Shape} style={{ width: '65px', height: '17px', marginBottom: '20px' }} alt="" />
            <div className="row" style={{
                fontSize: '12px',
                textAlign: 'left'
            }}>
                {/*Col 1 */}
                <div className="col" style={{
                    fontSize: '12px',
                    lineHeight: '25px',
                    fontWeight: '400'
                }}>
                    <ul className="list-unstyled">
                        <li>CONTACT US</li>
                        <li>HELP</li>
                        <li>TERMS OF SERVICE</li>
                        <li>PHILIPMORRISUSA.COM</li>
                    </ul>
                </div>
                {/*Col 2 */}
                <div className="col" style={{
                    fontSize: '12px',
                    lineHeight: '25px',
                    fontWeight: '400'
                }}>
                    <ul className="list-unstyled">
                        <li>SHOP IQOS</li>
                        <li>PRIVACY STATEMENT</li>
                        <li>TOBACCORIGHTS.COM</li>
                        <li>RESPONSIBILITY</li>
                    </ul>
                </div>

            </div>
            <div style={{
                fontSize: '12px',
                lineHeight: '25px',
                fontWeight: '400'
            }}>
                <p>© 2020 PHILIP MORRIS USA INC.</p>
            </div>
        </div>


    );
}

export default Footer;